export default __webpack_public_path__ + "static/嘉宾头像_史团委-17f16516bcb9a98fcdb79e5b9fbd3d8a.png";